import '../scss/main.scss';

window.addEventListener('DOMContentLoaded', function(){
    var overlayElement = document.getElementsByClassName('overlay-360');
    if(overlayElement.length > 0){
        overlayElement[0].addEventListener('click', removeOverlay);

        function removeOverlay() {
            this.style.opacity = '0';
            setTimeout( function(){ overlayElement[0].style.zIndex = '-1'; }, 300);
            document.getElementById('close').style.display = 'block';
        }

        var closeButton = document.getElementById('close');
        closeButton.addEventListener('click', displayOverlay);

        function displayOverlay() {
            this.style.display = "none";
            overlayElement[0].style.zIndex = '1';
            overlayElement[0].style.opacity = '1';
        }
    }
});